<template >

<div>


<div class="info">

    <el-card class="box-card" shadow="never" :body-style='{padding:"0 20px"}'>

      <el-card>

               <a style="text-decoration:none;color:#337ab7;cursor:pointer; float: left; line-height: 36px; margin-top:-12px;" @click="returnBack">返回</a>

      </el-card>
      <el-card class="box-card" shadow="never">

        <div slot="header">

          <tableHeader title="买家信息" />
        </div>
        <div class="person-info">
          <p>支付方式：{{payTypeName}}</p>
          <p>用户名称：{{userAddress.nickName}}</p>
          <p>收货地址：{{address}}</p>
          <p>联系电话：{{userAddress.phoneNumber}}</p>
        </div>
      </el-card>

      <el-card class="box-card" shadow="never" :body-style='{padding:" 20px 0"}'>
        <div slot="header">
          <tableHeader title="物流信息" />
        </div>
        <el-table :data="tradeData.expressInfo" border style="width: 100%;min-height:0">

          <el-table-column prop="expressId" label="包裹" width="80" align='center'>
          </el-table-column>
          <el-table-column prop="deliveryCompany" label="物流公司名称" align='center'>
          </el-table-column>
          <el-table-column prop="expressStatus" label="物流状态" align='center'>
            <template slot-scope="scope">
              <span>{{scope.row.expressStatus==0?'待发货':'已发货'}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="courierNumb" label="运单号" align='center'>
          </el-table-column>
          <el-table-column prop="deliveryTime" label="发货时间" align='center'>
          </el-table-column>
          <el-table-column label="操作" align='center'>
            <template slot-scope="scope">
              <el-button v-if='scope.row.expressStatus===0' type="text" size="small"  @click="popNewAddPic">马上发货</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-card>

      <el-card class="box-card" shadow="never" :body-style='{padding:" 20px 0"}'>
        <div slot="header">
          <tableHeader title="订单信息" />
        </div>
        <div class="order-info">
          <span>订单编号：{{tradeData.cpOrderId}}</span>
          <span>下单时间：{{tradeData.tradeTime}}</span>

        </div>
        <el-table :data="tradeData.userTradeDetail" border style="width: 100%;min-height:0">

          <el-table-column prop="tradeTime" label="商品图片" align='center'>
            <template slot-scope="scope">
            <div class="commodity">
              <img :src="scope.row.commodityIcon" alt="" style="width:50px;vertical-align:middle;margin:10px;">
            </div>
            </template>
          </el-table-column>
          <el-table-column prop="commodityName" label="商品名称" align='center'>
          </el-table-column>
          <el-table-column prop="commodityPrice" label="单价（元）" align='center'>
            <template slot-scope="scope">
              <span class="red">￥{{scope.row.commodityPrice/100}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="tradeCount" label="数量" align='center'>
            <template slot-scope="scope">
              <span>{{scope.row.tradeCount}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="address" label="商品总价（元）" align='center'>
            <template slot-scope="scope">
              <span class="red">￥{{(scope.row.commodityPrice*scope.row.tradeCount/100)}}</span>
            </template>
          </el-table-column>
        </el-table>

        <div class="total">
          <p>订单商品金额：¥{{tradeData.totalPrice/100}}元</p>
          <p>实收款：¥{{tradeData.totalPrice/100}}元</p>
        </div>
      </el-card>
    </el-card>
    <po-add-pic
      :add-show="addPicShow"
      :fx-level-obj="expressInfo"
      :fx-trade-id="tradeId"
      @closeAddAccount="closeAddPic"></po-add-pic>
  </div>


</div>
</template>
<script>

//import refund from './Dialog/refund.vue'
//import deliver from './Dialog/deliver.vue'
//import logisticsInfo from './Dialog/logisticsInfo.vue'
import {getQueryString, isNull} from '../../js/tool'
import $axios from '../../https/config'
import poNewAddPic from '@/page/fxshop/fxTradeExpress'

export default {
  data () {
    return {
      addPicShow: false,
      tradeData: {},
      customAccount:{},
      expressInfo:{},
      tradeId:'',
      userAddress:{},
      payTypeName: ''
    }
  },
  created: function () {
      this.getTradeOrderDetail()
  },
  methods: {
    getTradeOrderDetail: function () {
        var cpOrderId = getQueryString('cpOrderId')
        if (isNull(cpOrderId)){
          return
        }
        //调用查询订单详情接口
        var _this = this

        var url = '/order/queryTradeOrderInfo'
        var params = {
          cpOrderId:cpOrderId
        }
        $axios.get(url, params, 'headers', function (res) {
        if (res && res.resultStatus === true) {
          if (res.resultData) {
             _this.tradeData = res.resultData
             _this.tradeId = res.resultData.tradeId
             _this.customAccount = res.resultData.customAccount
             _this.userAddress = res.resultData.userAddress
             _this.expressInfo = res.resultData.expressInfo
             _this.payTypeName = "余额支付"
             if (res.resultData.payType==3){
              _this.payTypeName = "易宝支付"
             }


             console.log(JSON.stringify(_this.tradeData));
          }
        } else {
        }
        _this.table_loading = false
      })
    },
    popNewAddPic () {
      this.addPicShow = true
    },
    closeAddPic () {
      this.addPicShow = false

      this.getTradeOrderDetail()
    },
    returnBack () {
        this.$router.back(-1)
    }
  },
  components: {
    'po-add-pic': poNewAddPic
  },

   computed: {
    address() {
      //return this.userAddress.province + " " + this.userAddress.city + " " + this.userAddress.region + " " + this.userAddress.detailAddress
      return this.userAddress.detailAddress
    }
  },


  destroyed() { //页面卸载如果有循环 则停止循环
    //clearTimeout(this.time);
  },
  mounted() {
    //this.findOrderInfobyCpOrderIdV2();
  }
}
</script>



<style lang="scss" scoped>
ul {
    margin: 20px 0;
    li {
        display: flex;
        align-items: center;
        line-height: 16px;
        margin: 10px 0;
        font-size: 14px;
        color: #606266;
        &:before {
            content: "";
            width: 8px;
            height: 8px;
            margin-right: 5px;
            background-color: #606266;
            border-radius: 50%;
        }
    }
}
.el-card {}

.el-steps {
    padding: 20px 0;
}
.status {
    margin-top: 20px;
    p {
        color: #303133;
    }
}
.info,
.status {
    .el-card {
        margin-bottom: 20px;
        .el-card {
            border: none;
        }
    }
}
.info {
    .person-info {
        p {
            padding: 5px 0;
        }
    }

    .order-info {
        padding-bottom: 20px;
        span {
            margin-right: 50px;
            color: #606266;
        }
    }
}
.total {
    display: flex;
    flex-direction: column;
    padding-top: 20px;
    p {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        padding: 5px 0;
        color: #606266;
    }
}
</style>



// WEBPACK FOOTER //
// src/page/fxshop/fxTradeOrderDetail.vue